import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "topbar" }
const _hoisted_4 = { class: "topbar-right" }
const _hoisted_5 = { class: "pill" }
const _hoisted_6 = {
  key: 0,
  class: "item-card"
}
const _hoisted_7 = {
  key: 1,
  class: "grid card-list"
}
const _hoisted_8 = { class: "item-title" }
const _hoisted_9 = { class: "item-meta" }
const _hoisted_10 = { class: "actions" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("div", null, [
          _createElementVNode("h1", { class: "title" }, "Submissoes de relatorios"),
          _createElementVNode("p", { class: "subtitle" }, "Relatorios diarios e incidentes registrados.")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.roleLabel), 1),
          _createElementVNode("button", {
            class: "btn btn-ghost",
            type: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goHome && _ctx.goHome(...args)))
          }, "Inicio"),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-ghost",
                type: "button",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goToAdmin && _ctx.goToAdmin(...args)))
              }, " Ir para admin "))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "btn btn-ghost",
            type: "button",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
          }, "Sair"),
          _createElementVNode("button", {
            class: "icon-btn",
            type: "button",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.create && _ctx.create(...args)))
          }, "+")
        ])
      ]),
      (_ctx.items.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[5] || (_cache[5] = [
            _createElementVNode("h3", { class: "item-title" }, "Nenhuma submissao por aqui", -1),
            _createElementVNode("p", { class: "item-meta" }, "Clique no + para criar o primeiro relatorio.", -1)
          ]))]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.id,
                class: "item-card"
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("h3", _hoisted_8, _toDisplayString(item.title) + " - " + _toDisplayString(item.attraction) + " - " + _toDisplayString(_ctx.formatReportDate(item.reportDate)), 1),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.formatDate(item.createdAt)) + " - " + _toDisplayString(item.status === 'rascunho' ? 'Rascunho' : 'Enviado'), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("button", {
                    class: "btn btn-secondary",
                    type: "button",
                    onClick: ($event: any) => (_ctx.view(item.id))
                  }, "Visualizar", 8, _hoisted_11),
                  _createElementVNode("button", {
                    class: "btn btn-ghost",
                    type: "button",
                    onClick: ($event: any) => (_ctx.edit(item.id))
                  }, "Editar", 8, _hoisted_12),
                  _createElementVNode("button", {
                    class: "btn btn-accent",
                    type: "button",
                    onClick: ($event: any) => (_ctx.remove(item.id))
                  }, "Excluir", 8, _hoisted_13)
                ])
              ]))
            }), 128))
          ]))
    ])
  ]))
}